<template>
  <div class="identityPage">
    <div class="taxTip">
     根据监管规定，金融机构及其委托代销机构必须对新开户客户开展尽职调查。请您如实确认您的税收居民信息。
    </div>
    <div class="identityType">
      <van-radio-group v-model="radioChecked" @change="onChange">
        <van-radio
          :name="item.radioIndex"
          v-for="item in radioItem"
          class="cosStyle"
          :key="item.radioIndex"
        >
          {{ item.radioTheme }}
          <template #icon="props">
            <img
              class="img-icon"
              :src="props.checked ? clickedIcon : unClickedIcon"
            />
          </template>
        </van-radio>
      </van-radio-group>
    </div>
    <template v-if="showIndexOne">
      <div class="emptyDiv"></div>
      <van-form>
        <van-field
          v-model="personalObj.familyName"
          name="familyName"
          label="拼音/英语姓"
          placeholder="请输入拼音/英语姓"
          @focus="changeWarnColor"
          input-align="right"
          :formatter="formatterEntry"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
        />
        <van-field
          v-model="personalObj.lastName"
          name="lastName"
          label="拼音/英语名"
          placeholder="请输入拼音/英语名"
          @focus="changeWarnColor"
          :formatter="formatterEntry"
          input-align="right"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
        />
        <div class="emptyDiv"></div>
        <div class="chinaTip">
          <div class="aboutSure">
            本人确认信息真实、准确和完整，且当上述信息发生变更时，本人将及时更新，否则自行承担相应后果。
          </div>
        </div>
        <div class="sureBtn">
          <van-button
            :disabled="!isDisabled2"
            :class="{ cancelBtn: !isDisabled2 }"
            round
            block
            color="#E12817"
            v-throttle="[onSubmit, `click`, 3000]"
            native-type="button"
            >提交</van-button
          >
        </div>
      </van-form>
    </template>
    <template v-if="showIndexOther">
      <div class="emptyDiv"></div>
      <van-form>
        <van-field
          v-model="personalObj.familyName"
          name="familyName"
          label="拼音/英语姓"
          placeholder="请输入拼音/英语姓"
          @focus="changeWarnColor"
          input-align="right"
          :formatter="formatterEntry"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
        />
        <van-field
          v-model="personalObj.lastName"
          name="lastName"
          label="拼音/英语名"
          @focus="changeWarnColor"
          placeholder="请输入拼音/英语名"
          input-align="right"
          :formatter="formatterEntry"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
        />
        <van-field
          readonly
          clickable
          name="bornCountry"
          :value="personalObj.bornCountry"
          label="出生国家/地区"
          placeholder="请选择"
          right-icon="arrow"
          input-align="right"
          @click="choiceMyCountry('01')"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
        />
        <van-field
        v-if="personalObj.bornCountryF == '0'"
          v-model="personalObj.bornCountryEN"
          name="bornCountryEN"
          label="出生国家/地区(英文) "
          placeholder="请输入出生国家/地区(英文)"
          @focus="changeWarnColor"
          input-align="right"
          :formatter="formatterEntry"
        />
        <div class="emptyDiv"></div>
        <van-field
          readonly
          clickable
          name="liveCountry"
          :value="personalObj.liveCountry"
          label="现居国家/地区"
          right-icon="arrow"
          placeholder="请选择"
          input-align="right"
          @click="choiceMyCountry('02')"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
        />
        <van-field
          readonly
          clickable
          name="liveProvince"
          :value="personalObj.liveProvince"
          label="现居省市县/区"
          placeholder="请选择"
          input-align="right"
          right-icon="arrow"
          v-if="showProvince"
          @click="onArea"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
        />
        <van-field
          v-model="personalObj.address"
          name="address"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          placeholder="请输入详细地址"
          @focus="changeWarnColor"
          v-if="showProvince"
          :formatter="formatterMultip"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
          show-word-limit
        />
        <div class="emptyDiv"></div>
        <van-field
          v-model="personalObj.liveCityEN"
          name="liveCityEN"
          label="现居城市(英文)"
          placeholder="请输入现居城市"
          @focus="changeWarnColor"
          input-align="right"
          :formatter="formatterEntry"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
        />
        <van-field
          v-model="personalObj.addressEN"
          name="addressEN"
          rows="2"
          autosize
          type="textarea"
          maxlength="50"
          :formatter="formatteEntip"
          placeholder="请输入详细地址(英文/拼音)"
          @focus="changeWarnColor"
          :rules="[{ required: true, trigger: 'onSubmit' }]"
          show-word-limit
        />
        <div class="emptyDiv"></div>
        <div class="addTaxCountry">
          <div
            class="taxCountryList"
            v-for="(item, index) in chins"
            :key="index"
          >
            <div class="taxCountryList__title">
              <div>税收居民国{{ index + 1 }}</div>
              <div
                class="setIcon"
                v-show="chins.length > 1"
                @click="deleteTaxModule(index)"
              >
                <van-icon name="delete-o" />
              </div>
            </div>
            <div class="taxCountryList__det">
              <van-field
                readonly
                clickable
                :name="'taxCountry' + index"
                :value="item.nameCountry"
                label="税收居民国家"
                placeholder="请选择"
                input-align="right"
                @click="showTaxDetail('1:' + index)"
                right-icon="arrow"
                :rules="[{ required: true, trigger: 'onSubmit' }]"
              />
              <van-field
                readonly
                clickable
                :name="'isTaxNum' + index"
                :value="item.isTaxNumber"
                label="是否存在纳税人识别号"
                placeholder="请选择"
                input-align="right"
                right-icon="arrow"
                @click="showTaxNumDet(index)"
                :rules="[{ required: true, trigger: 'onSubmit' }]"
              />
              <van-field
                v-if="item.chooseTaxRegisterNum == '1'"
                v-model="item.taxRegisterNo"
                :name="'taxNumber' + index"
                label="纳税人识别号"
                placeholder="请输入纳税人识别号"
                @focus="changeWarnColor"
                input-align="right"
                left-icon="question-o"
                class="customIcon"
                :formatter="formatterMultip"
                @click-left-icon="searchTaxDes"
                :rules="[{ required: true, trigger: 'onSubmit' }]"
              />
              <van-field
              v-if="item.chooseTaxRegisterNum == '0'"
                v-model="item.nullReason"
                :name="'taxNotReason' + index"
                rows="2"
                autosize
                type="textarea"
                @focus="changeWarnColor"
                maxlength="50"
                placeholder="请输入不能取得识别号原因"
                :formatter="formatterMultip"
                :rules="[{ required: true, trigger: 'onSubmit' }]"
                show-word-limit
              />
            </div>
          </div>
          <div class="addTaxList">
            <van-icon name="add-o" class="iconStyle" />
            <span @click="addTaxPersonC">添加税收居民国</span>
          </div>
        </div>
        <div class="emptyDiv"></div>
        <upload-file
          :uploadTitle="uploadHead"
          ref="uploadFile"
          certUploadType="1"
          @imgList="closeMain"
        ></upload-file>
        <div class="aboutStatement">
          <div class="aboutSure">
            本人确认信息真实、准确和完整，且当上述信息发生变更时，本人将及时更新，否则自行承担相应后果。
          </div>
        </div>
        <div class="sureBtn">
          <van-button
            round
            block
            color="#E12817"
            v-throttle="[onSave, `click`, 3000]"
            native-type="button"
            class="btn-right"
            >保存</van-button
          >
          <van-button
            :disabled="!isDisabled3"
            :class="{ cancelBtn: !isDisabled3 }"
            round
            block
            color="#E12817"
            v-throttle="[onSubmit, `click`, 3000]"
            native-type="button"
            >提交</van-button
          >
        </div>
      </van-form>
    </template>

    <van-popup v-model="areaShowPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="locationList"
        @change="onChangeArea"
        @confirm="onConfirmArea"
        @cancel="areaShowPicker = false"
      />
    </van-popup>
    <van-popup v-model="showTaxCountry" position="bottom">
      <van-area
        :area-list="areaList"
        @confirm="getTaxCountry"
        @cancel="showTaxCountry = false"
      />
    </van-popup>
    <van-popup v-model="showTaxNum" position="bottom">
      <van-picker
        show-toolbar
        :columns="showColumn"
        @confirm="getChoice"
        @cancel="showTaxNum = false"
      />
    </van-popup>
    <van-popup v-model="countryShowPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="countryList"
        value-key="chnTrivialName"
        @confirm="onConfirmCountry"
        @cancel="countryShowPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import _ from "lodash";
import bus from "@config/bus.js";
import { mapState } from "vuex";
import UploadFile from "../../../components/uploadFile.vue";
import{getCurrentRedisData} from '../../../util/util'
export default {
  name: "identityDes",
  data() {
    return {
      radioItem: [
        {
          radioTheme: "仅为中国税收居民",
          radioIndex: "0",
        },
        {
          radioTheme: "仅为非居民 ",
          radioIndex: "1",
        },
        {
          radioTheme: "同为中国和其他国税收居民",
          radioIndex: "2",
        },
      ],
      unClickedIcon: require("../../../assets/images/accpunt/dwxz.png"),
      clickedIcon: require("../../../assets/images/accpunt/dyxz.png"),
      showTime: false,
      showArea: false,
      showTaxNum: false,
      areaList: [],
      showColumn: [
        {
          text: "否",
          value: "0",
        },
        {
          text: "居民国不发放",
          value: "2",
        },
        {
          text: "是",
          value: "1",
        },
      ], //0否，1是，2居民不发放
      taxPerson: "",
      fileList: [],
      uploaderFile: [],
      clickIndex: "",
      chins: [
        {
          nameCountry: "",
          isTaxNumber: "",
          taxRegisterNo: "",
          payTaxesCountryId: "",
          chooseTaxRegisterNum: "",
          nullReason: "",
        },
      ],
      showTaxCountry: false,
      personFlag: "",
      numberFlag: 0,
      countryShowPicker: false,
      countryFlag: "",
      countryList: [],
      personalObj: {
        username: "",
        familyName: "",
        lastName: "",
        bornDate: "",
        bornCountry: "",
        bornCountryId: "",
        bornCountryF: "",
        bornCountryEN: "",
        liveCountry: "",
        liveCountryId: "",
        liveCountryPirId: "",
        liveProvince: "",
        liveProvinceId: "",
        address: "",
        liveCityEN: "",
        addressEN: "",
        checkIbdex: "",
      },
      areaShowPicker: false,
      locationList: [
        {
          values: [],
          defaultIndex: 0,
        },
        {
          values: [],
          defaultIndex: 0,
        },
        {
          values: [],
          defaultIndex: 0,
        },
      ],
      params: {},
      radioChecked: "",
      uploadFileList: [],
      showProvince: true,
      showIndexOne: false,
      showIndexOther: false,
      uploadHead: "请上传您的个人税收材料",
      changeRadio: 0,
      //合并验证
      mergerVerifyFlag1: false,
      mergerVerifyFlag2: false,

      //btn flag
      isDisabled2: false,
      isDisabled3: false,
      currentParentId: null, //当前省
      currentCityId: null, //当前市
      //省市二次更改(市县和省不统一)
      lock: null,
      addressIndex: null,
      picFlag:false,
      chinaFlag:false,
      notChinaFlag:false,
      submitCount:0
    };
  },
  components: {
    UploadFile,
  },
  computed: {
    ...mapState(["getOpenAccount", "taxVal", "noIdentity", "accountCompany"]),
    verifyData() {
      const { mergerVerifyFlag1, picFlag, chinaFlag,notChinaFlag} =
        this;
      return { mergerVerifyFlag1, picFlag, chinaFlag,notChinaFlag};
    },
    leaveDataNew() {
      return JSON.parse(JSON.stringify(this.chins));
    },
    picData(){
      return _.cloneDeep(this.uploadFileList)
    },
    taxInfo(){
      return _.cloneDeep(this.personalObj)
    }
  },
  watch: {
    picData:{
      handler(newV){
        if(newV.length > 0){
          this.picFlag = true
        }else{
          this.picFlag = false
        }
      }
    },
    leaveDataNew: {
      handler(newValue, oldValue) {
        //合并监听
        for (let i = 0; i < newValue.length; i++) {
          if (newValue[i].isTaxNumber == "否") {
            if (newValue[i].nullReason) {
              this.mergerVerifyFlag1 = true;
            } else {
              this.mergerVerifyFlag1 = false;
            }
          } else if (newValue[i].isTaxNumber == "是") {
            if (newValue[i].taxRegisterNo) {
              this.mergerVerifyFlag1 = true;
            } else {
              this.mergerVerifyFlag1 = false;
            }
          } else {
            if (newValue[i].nameCountry && newValue[i].isTaxNumber) {
              this.mergerVerifyFlag1 = true;
            } else {
              this.mergerVerifyFlag1 = false;
            }
          }
          // break;
        }
      },
      immediate: false,
      deep: true,
    },
    taxInfo:{
      handler(val){
        if (this.changeRadio == 0) {
          if (val.familyName && val.lastName) {
            this.chinaFlag = true;
          } else {
            this.chinaFlag = false;
          }
        }else{
          if (
            val.familyName &&
            val.lastName &&
            val.bornCountry &&
            val.liveCountry &&
            val.liveCityEN &&
            val.addressEN 
          ) {
            if (['156'].includes(val.liveCountryId)) {
              if (val.liveProvince && val.address) {
                this.notChinaFlag = true;
              } else {
                this.notChinaFlag = false;
              }
            } else {
              this.notChinaFlag = true;
            }
            if (val.bornCountryF != '0') {
              this.notChinaFlag = true;
            } else {
              if(val.bornCountryEN){
                this.notChinaFlag = true;
              }else{
                this.notChinaFlag = false;
              }
            }
          } else {
            this.notChinaFlag = false;
          }
        }
      }
    },
    verifyData:{
      handler(newV){
        if(this.changeRadio == 0){
          if(
            newV.chinaFlag
          ){
            this.isDisabled2 = true
          }else{
            this.isDisabled2 = false
          }
        }else{
          if(
            newV.notChinaFlag &&
            newV.mergerVerifyFlag1 &&
            newV.picFlag
          ){
            this.isDisabled3 = true
          }else{
            this.isDisabled3 = false
          }
        }
      }
    }
  },
  mounted() {
    if (this.IOS.ios()) {
      window.getPictureUrl = this.getMaterial;
    } else {
      // 安卓传值给h5
      window["getPictureUrl"] = (val) => {
        this.getMaterial(val);
      };
    }
    this.personalObj.liveCountry = this.noIdentity.liveCountry;
    this.personalObj.liveCountryId = this.noIdentity.liveCountryId;
    this.personalObj.liveProvince = this.noIdentity.liveProvince;
    this.personalObj.liveProvinceId = this.noIdentity.liveProvinceId;
    this.personalObj.address = this.noIdentity.address;
    if(this.noIdentity.liveCountryId == '156'){
      this.showProvince = true;
    }else{
      this.showProvince = false;
      this.personalObj.liveProvince = '';
      this.personalObj.liveProvinceId = '';
      this.personalObj.address = '';
    }
  },
  methods: {
    //只能输入英文
    formatterEntry(val) {
      return val.replace(/[^\a-\z\A-\Z]/g, "");
    },
    //不能输入表情
    formatterMultip(val) {
      return val.replace(
        /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g,
        ""
      );
    },
    formatteEntip(val){
      let reg = /[\u4e00-\u9fa5]/g
      let reg2 = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g
      if(reg.test(val)){
       return val.replace(reg,'')
      }else if(reg2.test(val)){
       return val.replace(reg2,'')
      }else{
        return val
      }
    },
    closeMain(a) {
      if (a.length == 0) {
        this.isDisabled3 = false;
      }
      this.uploadFileList = [...a]
    },
    changeWarnColor(e) {
      e.target.style.color = "#333";
    },
    searchTaxDes() {
      this.$dialog.alert({
        message: `纳税人识别号：是由税收居民国分配给个人或机构，用于识别并管理税收个人或机构的一串独一无二的号码。更多纳税人识别号相关信息请参见国家税务总局网站。（http://www.chinatax.gov.cn/aeoi_index.html）。`,
        messageAlign: "left",
      });
    },
    getMaterial(val) {
      this.$refs.uploadFile.showMaterial(val);
      if (this.IOS.ios()) {
        val = val.uploadFile;
      } else {
        val = JSON.parse(val).uploadFile;
      }
      val.map((item) => {
        this.uploadFileList.unshift(item);
      });
    },
    async onChange(val) {
      // 同为中国和其他国税收居民
       this.changeRadio = val;
      if (val === "0") {
         this.$dialog.alert({
            title: "",
            message: '请您联系我司服务人员，协助提交认定及相关材料',
            confirmButtonText: "确定",
            messageAlign: "left",
          }).then(()=>{
            this.showIndexOne = false;
            this.showIndexOther = false;
            this.changeRadio = ''
            this.radioChecked = ''
          });
        let namePY = await this.getFirstName(this.getOpenAccount.fullName)
        this.personalObj.familyName = namePY.englishSurName
        this.personalObj.lastName = namePY.englishGivenName
        this.showIndexOne = true;
        this.showIndexOther = false;
        this.uploadFileList = []
      } else if(val === "1" || val === "2"){
        this.showIndexOne = false;
        this.showIndexOther = true;
      }
       this.personalObj = _.cloneDeep(this.personalObj)
    },
    getFirstName(name){
      let param = {
        name
      }
      return new Promise((resolve,reject)=>{
        this.$post(this.$api.convertPinyin, param).then(res =>{
          res.code === 10000 ? resolve(res.data) : resolve()
        })
      })
    },
    onConfirmArea(val) {
      this.areaShowPicker = false;
      if (!this.currentCityId) {
        this.currentCityId = val[1].text;
      }
      if (this.lock) {
        this.personalObj.liveProvince = `${val[0].text}/${val[1].text}/${val[2].text}`;
        this.personalObj.liveProvinceId = `${val[0].code}/${val[1].code}/${val[2].code}`;
      }
    },
    onArea() {
      if (this.addressIndex) {
        if (this.addressIndex != 2) {
          this.lock = false;
        }
      }
      let _this = this;
      _this.areaShowPicker = true;
      if (_this.personalObj.liveCountryId == "156") {
        _this.params = { isRemove: 1 };
      }
      _this.$post(_this.$api.getLocationList, _this.params).then((res) => {
        if (res.code === 10000) {
          _this.locationList[0].values = Object.values(res.data).map(function (
            e
          ) {
            return {
              text: e.areaName,
              code: e.id,
            };
          });
          if (this.personalObj.liveCountryId == "156") {
            _this
              .$post(_this.$api.getLoadCity, {
                parentId:
                  this.currentParentId || _this.locationList[0].values[0].code,
              })
              .then((res) => {
                if (res.code === 10000) {
                  _this.locationList[1].values = Object.values(res.data).map(
                    function (e) {
                      return {
                        text: e.areaName,
                        code: e.id,
                      };
                    }
                  );
                  _this
                    .$post(_this.$api.getLoadArea, {
                      parentId:
                        this.currentCityId ||
                        _this.locationList[1].values[0].code,
                    })
                    .then((res) => {
                      this.lock = true;
                      if (res.code === 10000) {
                        _this.locationList[2].values = Object.values(
                          res.data
                        ).map(function (e) {
                          return {
                            text: e.areaName,
                            code: e.id,
                          };
                        });
                      }
                    });
                }
              });
          }
        }
      });
    },
    onChangeArea(picker, values, index) {
      this.addressIndex = index;
      if (this.addressIndex != 2) {
        this.lock = false;
      }
      this.currentParentId = values[0].code;
      if (index === 0) {
        this.$post(this.$api.getLoadCity, {
          parentId: this.currentParentId || values[0].code,
        }).then((res) => {
          if (res.code === 10000) {
            if (this.lock) {
              this.currentCityId = res.data[0].id;
            }
            this.locationList[1].values = Object.values(res.data).map(function (
              e
            ) {
              return {
                text: e.areaName,
                code: e.id,
              };
            });
            this.$post(this.$api.getLoadArea, {
              parentId: res.data[0].id,
            }).then((res) => {
              if (res.code === 10000) {
                this.lock = true;
                this.locationList[2].values = Object.values(res.data).map(
                  function (e) {
                    return {
                      text: e.areaName,
                      code: e.id,
                    };
                  }
                );
              }
            });
          }
        });
      } else if (index === 1) {
        this.$post(this.$api.getLoadArea, { parentId: values[1].code }).then(
          (res) => {
            if (res.code === 10000) {
              this.lock = true;
              this.locationList[2].values = Object.values(res.data).map(
                function (e) {
                  return {
                    text: e.areaName,
                    code: e.id,
                  };
                }
              );
            }
          }
        );
      }
    },
    choiceMyCountry(id, val) {
      let _this = this;
      this.countryFlag = id;
      this.countryShowPicker = true;
      this.$post(this.$api.getLocation, {}).then((res) => {
        if (res.code === 10000) {
          let data = res.data;
          if (id === "01") {
            data.unshift({
              chnTrivialName: "无",
              id: "",
              figure:"0"
            });
          }
          _this.countryList = data;
        }
      });
    },
    onConfirmCountry(val) {
      if (this.countryFlag === "01") {
        this.personalObj.bornCountry = val.chnTrivialName;
        this.personalObj.bornCountryId = val.id;
        this.personalObj.bornCountryF = val.figure;
      }
      if (this.countryFlag === "02") {
        this.personalObj.liveCountry = val.chnTrivialName;
        this.personalObj.liveCountryPirId = val.id;
        this.personalObj.liveCountryId = val.figure;
        if (val.figure == "156") {
          this.showProvince = true;
        } else {
          this.showProvince = false;
          this.personalObj.liveProvince = "";
          this.personalObj.liveProvinceId = "";
          this.personalObj.address = "";
        }
      }
      if (
        val.figure == "446" ||
        val.figure == "158" ||
        val.figure == "344"
      ) {
        //香港
        this.locationList = [{ values: [], defaultIndex: 0 }];
      } else if (val.figure == "156") {
        this.locationList = [
          { values: [], defaultIndex: 0 },
          { values: [], defaultIndex: 0 },
          { values: [], defaultIndex: 0 },
        ];
      }
      if (this.personFlag) {
        let index = this.personFlag.split(":")[1];
        let dep = _.cloneDeep(this.chins[index]);
        dep.nameCountry = val.chnTrivialName;
        dep.payTaxesCountryId = val.figure;
        this.$set(this.chins, index, dep);
      }
      this.countryShowPicker = false;
      this.personFlag = "";
    },
    choiceArea(values) {
      let val = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      if (this.clickIndex === "01") this.bornCountry = val;
      if (this.clickIndex === "02") this.liveCountry = val;
      if (this.clickIndex === "03") this.liveProvince = val;
      this.showArea = false;
    },
    getTaxCountry(value) {
      let num = this.personFlag;
      let val = value
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      let dep = _.cloneDeep(this.chins[num]);
      dep.nameCountry = val;
      this.$set(this.chins, num, dep);
      this.showTaxCountry = false;
    },
    getChoice(val) {
      let numF = this.numberFlag;
      let dep = _.cloneDeep(this.chins[numF]);
      dep.isTaxNumber = val.text;
      dep.chooseTaxRegisterNum = val.value;
      dep.nullReason = ''
      dep.taxRegisterNo = ''
      this.$set(this.chins, numF, dep);
      this.showTaxNum = false;
    },
    addTaxPersonC() {
      this.chins.push({
        nameCountry: "",
        isTaxNumber: "",
        chooseTaxRegisterNum: "",
        taxRegisterNo: "",
        payTaxesCountryId: "",
        nullReason: "",
      });
    },
    checkRadio() {
      // 点击单选按钮
    },
    checkTaxNumber(code,num,country,status){
      let obj = {}
      return new Promise((resolve,reject)=>{
        let param = {
          taxpayerIdNum:status,
          countryCode: code, //国家code
          value: num, //纳税人识别号
          personalEntityType:'1'
        }
        this.$post(this.$api.checkCRS, param).then((res) => {
          if(res.code === 10000 || res.code === 50000){
            obj = {
              country,
              result:res.code === 50000 ? '1' : res.data,
            }
            resolve(obj)
          }
        })
      })
    },
    getChinsVal(array){
      let proArray = []
      let p;
      for(let i of array){
        p = this.checkTaxNumber(i.payTaxesCountryId,i.taxRegisterNo,i.nameCountry,i.chooseTaxRegisterNum)
        proArray.push(p)
      }
      console.log('proArray',proArray)
      return proArray
    },
    onSave() {
      let params = {};
      params.countryId = this.noIdentity.liveCountryId;
      params.cityId = "";
      params.districtId = "";
      params.provinceId = "";
      params.isSpecifyNatural = "";
      params.isNegativeCredibilityRecord = "";
      params.address = "";
      params.email = "";
      params.vocationId = "";
      params.annualIncome = "";
      params.referenceMobileNum = "";
      params.taxPersonType = this.radioChecked;
      params.companyId = this.accountCompany;
      params.cmsGroupCustomerPersonId = this.noIdentity.groupPid || this.getOpenAccount.groupPid;
      params.cmsGroupCustomerCommonId = this.noIdentity.commonId || this.getOpenAccount.commonId;
      params.code = this.noIdentity.code || this.getOpenAccount.code;
      params.mobileDistrict = "156";
      params.type = "1";
      params.birthday = this.noIdentity.birthday || this.getOpenAccount.birthday;
      params.mobile = this.getOpenAccount.phone;
      params.badFaithDesc = "";
      params.customerName = this.noIdentity.name || this.getOpenAccount.name;
      console.log(this.personalObj.familyName,'this.personalObj.familyName');
      params.englishSurName = this.personalObj.familyName;
      params.englishGivenName = this.personalObj.lastName;
      params.addressCityEn = this.radioChecked !== '0' ? this.personalObj.liveCityEN : '';
      params.addressHomeEn = this.radioChecked !== '0' ? this.personalObj.addressEN : '';
      params.cmsCrsRegisterNoReq = this.radioChecked !== '0' ? this.chins : [];
      
      let finaF
      if(this.personalObj.bornCountryF != '0'){
        finaF = this.personalObj.bornCountryF
      }else{
        finaF = ""
      }
      params.countryOfBirth = this.radioChecked !== '0' ? finaF : '';
      params.bornCountry = this.personalObj.bornCountry;
      params.nowCountryName = this.personalObj.liveCountry;
      console.log(this.personalObj.liveProvince,"this.personalObj.liveCountry");
      params.nowProvinceName = this.personalObj.liveProvince;
      params.countryOfBirthEn = this.radioChecked !== '0' ? this.personalObj.bornCountryEN : '';
      params.nowAddress = this.radioChecked !== '0' ? this.personalObj.address : '';
      params.nowCountryId = this.radioChecked !== '0' ? this.personalObj.liveCountryId : '';
      params.nowProvinceId = this.radioChecked !== '0' ? this.personalObj.liveProvinceId.split("/")[0] : '';
      params.nowCityId = this.radioChecked !== '0' ? this.personalObj.liveProvinceId.split("/")[1] : '';
      params.file = this.radioChecked !== '0' ? this.uploadFileList : [];
      params.companyAccountId = this.noIdentity.companyAccountId || this.getOpenAccount.companyAccountId;
      params.companyPersonId = this.noIdentity.companyPersonId || this.getOpenAccount.companyPersonId;
      params.certificateType = this.noIdentity.certificateType || this.getOpenAccount.certificateType;
      params.groupSource = getCurrentRedisData(this.accountCompany);
      this.$post(this.$api.saveAccount, params).then((res) => {
        if (res.code === 10000) {
          this.$toast(res.message);
        } else {
          this.$toast(res.message);
        }
      });
    },
    onSubmit() {
      if (this.radioChecked !== "0" && this.uploadFileList.length <= 0) {
        this.$toast("请上传资料");
        return;
      }
      let flag1 = (this.personalObj.address&&this.personalObj.address.length<8) ? true : false
      let flag2 = (this.personalObj.addressEN&&this.personalObj.addressEN.length<8) ? true : false
      if(this.radioChecked !== "0" && (flag1 || flag2)){
        this.$toast("详细地址不能少于8个字符！")
        return
      }
      console.log(this.radioChecked,'this.radioChecked++++++')
      if(this.radioChecked === "0"){
        this.nextOpera()
        return
      }else if(this.radioChecked === "2"){
        if(this.chins.length < 2){
          this.$toast("同为中国和其它国税收居民，请至少填写2个税收居民国")
          return
        }
      }
      let arr = this.getChinsVal(this.chins)
      Promise.all(arr).then((res)=>{
        let obj = res.filter((item) => !item.result)
        let joinStr = ''
        obj.map((item,index)=>{
          joinStr+=`${item.country}${obj.length - 1 == index ? '' : ','}`
        })
        obj.length > 0 ?
        this.$dialog.confirm({
          message:`您填写的${joinStr}税收居民国信息与该国家/地区的信息校验有区别，请您核实`,
          cancelButtonText:'重新填写',
          confirmButtonText:'继续提交'
        }).then(()=>{
          this.nextOpera()
        }).catch(()=>{
        }) :
        this.nextOpera()
      }).catch(()=>{
        this.nextOpera()
      })
    },
    nextOpera(){
      let params = {};
      params.countryId = this.noIdentity.liveCountryId;
      params.cityId = "";
      params.districtId = "";
      params.provinceId = "";
      params.isSpecifyNatural = "";
      params.isNegativeCredibilityRecord = "";
      params.address = "";
      params.email = "";
      params.vocationId = "";
      params.annualIncome = "";
      params.referenceMobileNum = "";
      params.taxPersonType = this.radioChecked;
      params.companyId = this.accountCompany;
      params.cmsGroupCustomerPersonId = this.noIdentity.groupPid || this.getOpenAccount.groupPid;
      params.cmsGroupCustomerCommonId = this.noIdentity.commonId || this.getOpenAccount.commonId;
      params.code = this.noIdentity.code || this.getOpenAccount.code;
      params.mobileDistrict = "156";
      params.type = "1";
      params.birthday = this.noIdentity.birthday || this.getOpenAccount.birthday;
      params.mobile = this.getOpenAccount.phone;
      params.badFaithDesc = "";
      params.customerName = this.noIdentity.name || this.getOpenAccount.name;
      params.englishSurName = this.personalObj.familyName;
      params.englishGivenName = this.personalObj.lastName;
      params.addressCityEn = this.radioChecked !== '0' ? this.personalObj.liveCityEN : '';
      params.addressHomeEn = this.radioChecked !== '0' ? this.personalObj.addressEN : '';
      params.cmsCrsRegisterNoReq = this.radioChecked !== '0' ? this.chins : [];
      let finaF
      if(this.personalObj.bornCountryF != '0'){
        finaF = this.personalObj.bornCountryF
      }else{
        finaF = ""
      }
      params.countryOfBirth = this.radioChecked !== '0' ? finaF : '';
      params.countryOfBirthEn = this.radioChecked !== '0' ? this.personalObj.bornCountryEN : '';
      params.nowAddress = this.radioChecked !== '0' ? this.personalObj.address : '';
      params.nowCountryId = this.radioChecked !== '0' ? this.personalObj.liveCountryId : '';
      params.nowProvinceId = this.radioChecked !== '0' ? this.personalObj.liveProvinceId.split("/")[0] : '';
      params.nowCityId = this.radioChecked !== '0' ? this.personalObj.liveProvinceId.split("/")[1] : '';
      params.file = this.radioChecked !== '0' ? this.uploadFileList : [];
      params.companyAccountId = this.noIdentity.companyAccountId || this.getOpenAccount.companyAccountId;
      params.companyPersonId = this.noIdentity.companyPersonId || this.getOpenAccount.companyPersonId;
      params.certificateType = this.noIdentity.certificateType || this.getOpenAccount.certificateType;
      params.groupSource = getCurrentRedisData(this.accountCompany);
      if(this.submitCount > 0) return
      this.$post(this.$api.submitAccount, params).then((res) => {
        if (res.code === 10000) {
          this.submitCount+=1
          console.log(res.data,'shui');
          this.$router.push({
            path: "/personalProcess/notBankCard",
          });
          // this.countryList = res.data
        } else {
          let message;
          if (res.code === 80010) {
            message = "手机号不存在";
          } else if (res.code === 80011) {
            message = "无法绑定，您可联系客服咨询";
          } else {
            message = res.message;
          }
          this.$toast.loading({
            loadingType: "spinner",
            message: message,
          });
        }
      });
    },
    myCountryChoice(index) {
      this.showArea = true;
      this.clickIndex = index;
    },
    showTaxDetail(flag) {
      this.personFlag = flag;
      // this.showTaxCountry = true
      this.choiceMyCountry("00");
    },
    showTaxNumDet(index) {
      this.numberFlag = index;
      this.showTaxNum = true;
    },
    deleteTaxModule(index) {
      this.chins.splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.identityPage {
  background-color: #fff;
}
.emptyDiv {
  height: 0.16rem;
  width: 100%;
  background-color: #f5f5f5;
}
.taxTip {
  background-color: #f5f5f5;
  padding: 0.16rem;
  text-align: left;
  color: #c58935;
  font-size: 0.14rem;
}
.identityType {
  padding: 0 0.16rem;
  .cosStyle {
    padding: 0.16rem 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row-reverse;
    border-bottom: 1px solid #eeeeee;
    /deep/.van-radio__label {
      font-size: 0.15rem;
      color: #333333;
      margin: 0;
    }
    &:last-of-type {
      border: none;
    }
  }
}
/deep/.van-field__label {
  width: 1.4rem;
}
/deep/.van-radio {
  img {
    width: 0.16rem;
    height: 0.16rem;
  }
}
.addTaxCountry {
  .taxCountryList {
    position: relative;
    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0.16rem;
      right: 0.16rem;
      border-bottom: 1px solid #eeeeee;
    }

    &__title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font: {
        weight: bold;
        size: 0.17rem;
      }
      color: #333333;
      text-align: left;
      padding: 0.16rem 0;
      margin: 0 0.16rem;
      border-bottom: 1px solid #eeeeee;
      .setIcon {
        font-size: 0.2rem;
        color: #e12817;
      }
    }
  }
  .addTaxList {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.16rem;
    font: {
      size: 0.15rem;
      weight: bold;
    }
    color: #1677ff;
    .iconStyle {
      margin-right: 0.03rem;
      font: {
        size: 0.15rem;
        weight: bold;
      }
    }
  }
}
.customIcon {
  position: relative;
  /deep/.van-field__left-icon .van-icon {
    position: absolute;
    left: 106px;
  }
}
.uploadTaxFile {
  padding: 0.16rem 0.16rem 0.3rem;
  .addStyle {
    display: block;
    margin-top: 0.15rem;
  }
  &__title {
    text-align: left;
    font-size: 0.15rem;
    color: #333333;
  }
  /deep/.van-uploader__upload-icon {
    color: #e12817;
    font-size: 0.36rem;
  }
  /deep/.van-uploader__preview-image {
    width: 0.76rem;
    height: 0.76rem;
  }
  .uploadModule {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .defaultStyle {
    margin-top: 0.16rem;
    margin-right: 0.16rem;
    font-size: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    .iconWrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0.56rem;
      height: 0.56rem;
      background: #f5f5f5;
      font-size: 0;
      .customIcon {
        font-size: 0.18rem;
        color: #e12817;
      }
    }
    .uploadWord {
      font-size: 0.13rem;
      margin-top: 0.03rem;
      color: #666666;
    }
  }
  .imageWrapper {
    font-size: 0;
    position: relative;
    .customerImage {
      margin-top: 0.16rem;
      margin-right: 0.16rem;
      width: 0.56rem;
      height: 0.76rem;
    }
    .deleteIcon {
      position: absolute;
      right: 0.08rem;
      top: 0.08rem;
      font-size: 0.16rem;
      color: #cccccc;
      z-index: 9;
    }
  }
}
.aboutStatement {
  padding: 0.05rem 0.16rem 0.16rem;
  background-color: #f5f5f5;
  padding-bottom: 0.8rem;
  .aboutSure {
    margin-top: 0.16rem;
    text-align: left;
    font-size: 0.13rem;
    color: #666666;
  }
}
.chinaTip {
  position: fixed;
  bottom: 0.8rem;
  left: 0.16rem;
  right: 0.16rem;
  .aboutSure {
    margin-top: 0.16rem;
    text-align: left;
    font-size: 0.13rem;
    color: #666666;
  }
}
.sureBtn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #f5f5f5;
  box-sizing: border-box;
  padding: 0.1rem 0.16rem;
  z-index: 99;
  display: flex;
  &__det {
    font-size: 0.14rem;
    width: calc((100% - 0.49rem)/2);
    height: 0.49rem;
    top: 0.1rem;
    font-size: 0.17rem;
    background: #e12817;
    color: #fff;
    margin-left: 0.16rem;
  }
  .btn-right{
    margin-right: 0.17rem;
  }
  .cancelBtn {
    background: #cccccc !important;
    color: #fff !important;
    border: transparent;
  }
}
</style>